import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { PositionComparison } from '../models/position-comparison.model'
import { FlexPositionComparisonService } from './flex-position-comparison.service'

/**
 * Confirmed against the real backend's API docs: the route is `/api/flex-positions/comparison`,
 * mirroring `QUERY_URL` (http-workbench-data-source.ts) and `FIELD_CATALOG_URL`
 * (http-field-catalog.service.ts) — `flex-positions` appears twice, once as the proxy's routing
 * prefix and once as the service's own API path segment. Under `<base href="/helios/">` this
 * resolves to `/helios/helios-flex-positions/flex-positions/comparison`, which the dedicated
 * `helios-flex-positions` rule in proxy.conf.beta.json (dev) and the matching nginx
 * `location ^~ /helios/helios-flex-positions` block (prod) rewrite onto the flex-positions backend.
 *
 * The `helios-` host prefix is load-bearing: a bare `flex-positions/comparison` resolves under the
 * SPA base to `/helios/flex-positions/comparison`, which matches neither proxy rule nor an nginx
 * location block, so the catch-all returns index.html and the POST never reaches a backend.
 */
export const FLEX_POSITIONS_URL = `helios-flex-positions`
export const FLEX_POSITIONS_COMPARISON_URL = `${FLEX_POSITIONS_URL}/flex-positions/comparison`

@Injectable({
  providedIn: 'root',
})
export class HttpFlexPositionComparisonService extends FlexPositionComparisonService {
  constructor(private readonly http: HttpClient) {
    super()
  }

  getComparison(source: string, rowId: string): Observable<PositionComparison> {
    return this.http.post<PositionComparison>(FLEX_POSITIONS_COMPARISON_URL, {
      source,
      rowId,
    })
  }
}
